module.exports = __webpack_public_path__ + "img/user.e81354c2.svg";